module.exports = __webpack_public_path__ + "media/images/icons/icon-calculator-alt-01ae205dac8c320eca4a055a529ae06b.svg";